import MouvementStockProduitInfosController from './mouvement.stock.produit.infos.controller';
import Template from './mouvement.stock.produit.infos.html';

export default {
	bindings: {
		idRegoupementSite: '<',
		idProduit: '<',
		idProducteur: '<',
		mouvementProduitInfos: '='
	},
	controller: MouvementStockProduitInfosController,
	template: Template
};
